<template>
  <div
    class="skeleton"
    :style="{ width, height, borderRadius }"
    aria-hidden="true"
    role="presentation"
  />
</template>

<script setup>
defineProps({
  width: {
    type: String,
    default: '100%',
  },
  height: {
    type: String,
    default: '1em',
  },
  borderRadius: {
    type: String,
    default: '4px',
  },
});
</script>

<style scoped lang="scss">
.skeleton {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 37%, #f0f0f0 63%);
  background-size: 400% 100%;
  animation: skeleton-loading 1.4s ease infinite;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
